import { apiService, handleResponse } from '@/services/apiService';

export class CategoryRepository {
    async getCategories(data: { page: number, perPage: number, parentId?: number | null, userId?: number | null }) {
        const response = await apiService.post(`/v1/categories`, data);
        return handleResponse(response);
    }
    
    async getCategory(id: number, data: { page: number, perPage: number, parentId?: number | null, userId?: number | null }) {
        const response = await apiService.post(`/v1/categories/${id}`, data);
        return handleResponse(response);
    }
}
